<div class="panel-heading p0">
  <div class="bg-gray-darker p-lg mb-l">
    <h3 class="m0">{{ title }}</h3>
    <div *ngIf="!!subTitle" class="m0">{{ subTitle }}</div>
  </div>
</div>
